<template>
  <div>
    <h2 class="mb-2">Report Settings</h2>

    <v-row align="center">
      <v-col cols="12" sm="15" order="1" order-sm="1">
        <v-checkbox v-model="reportingEnabled" label="Send Weekly Reports via Email" @change="onCheckboxChange($event)"></v-checkbox>
        <!-- <v-select hide-details v-model="frequency" :items="['daily', 'weekly', 'monthly']" solo></v-select> -->
      </v-col>
    </v-row>

    <v-row align="center">

      <div v-if="!loadingReports">
        <div v-if="reports.length > 0">
          <ul>
          <div v-for="report in reports" :key="report.id">
            <router-link :to="`/device/${$route.params.id}/reports/${report.periodStartTimestamp}`">
              <li>
                <p>{{ report.period }} starting {{new Date(report.periodStartTimestamp * 1000).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }).replace(/\//g, '-')}}</p>
              </li>
            </router-link>
          </div>
        </ul>
        </div>
        <div v-else>
          <p>No reports found.  Reports are generated weekly, check back soon.</p>
        </div>
      </div>

    </v-row>

    <v-row align="center">

      <v-col cols="11" sm="5" order="1" order-sm="1">
      <router-link :to="`/device/${$route.params.id}/reports`">
          <p>View All</p>
        </router-link>
      </v-col>
      </v-row>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "reporting",
  data() {
    return {
      sensorId: "",
      reportingEnabled: false,
      loadingReports: true,
      reports: []
    };
  },
  components: {},

  async created() {
    this.sensorId = this.$store.state.sensor.sensorDetails.id;
    this.reportingEnabled = this.$store.state.sensor.sensorDetails.reportingEnabled;
    // console.log('sensorId: ', this.sensorId, this.$store.state.sensor.sensorDetails);
  },
  async mounted() {
    this.reports = await this.$store.dispatch("sensor/getSensorReports", {
        sensorId: this.sensorId,
        limit: 2
      });
    this.loadingReports = false;
  },
  computed: {
    ...mapGetters("user", ["isMDX", "isKDX", "isTDX", "isLocation"]),
  },
  methods: {

    async onCheckboxChange() {
      // console.log('user clicked reportingEnabled checkbox, saving new value:', this.reportingEnabled)

      if (!this.sensorId) {
        // console.log('Unable to update reportingEnabled without sensorId');
        return;
      }

      const result = await this.$store.dispatch("sensor/updateSensorPropertySimple", {
          id: this.sensorId,
          prop: 'reportingEnabled',
          value: this.reportingEnabled,
        });

      // console.log('save result: ', result);
    },

  },
};
</script>

<style lang="scss">
i {
  outline: none;
}
</style>
